import router from "next/router";
import { useRef, useEffect } from "react";
import videojs from "video.js";
import Player from "video.js/dist/types/player";
import "video.js/dist/video-js.css";

type VideoJSProps = {
  onReady?: (player: Player) => void;
  onPlay?: (player: Player) => void;
  onEnded?: () => void;
  onPlaying?: () => void;
  onWaiting?: () => void;
  onTimeUpdate?: (player: Player) => void;
  onLoaded?: (player: Player) => void;
  onLoadedMetadata?: (player: Player) => void;
  options: Record<string, any>;
  play: boolean;
  src: string;
  poster?: string;
};

export const VideoJS = ({
  onReady,
  onPlay,
  onEnded,
  options,
  play,
  src,
  poster,
  onPlaying,
  onWaiting,
  onTimeUpdate,
  onLoaded,
  onLoadedMetadata,
}: VideoJSProps) => {
  const videoRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<any>(null);

  useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement("video-js");

      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current?.appendChild(videoElement);

      playerRef.current = videojs(
        videoElement,
        {
          ...options,
          poster,
          sources: [{ src, type: "video/mp4" }],
        },
        () => {
          videojs.log("player is ready");
          onReady && onReady(playerRef.current);

          onPlay &&
            playerRef.current.on("play", () => onPlay(playerRef.current));
          onEnded && playerRef.current.on("ended", onEnded);

          onWaiting && playerRef.current.on("waiting", onWaiting);
          onTimeUpdate &&
            playerRef.current.on("timeupdate", () =>
              onTimeUpdate(playerRef.current)
            );
          onLoaded &&
            playerRef.current.on("loadeddata", () =>
              onLoaded(playerRef.current)
            );
          onLoadedMetadata &&
            playerRef.current.on("loadedmetadata", onLoadedMetadata);
          onPlaying && playerRef.current.on("playing", onPlaying);
        }
      );

      playerRef.current.on("error", () => {});

      playerRef.current.reloadSourceOnError({
        // customize your interval
        errorInterval: 3,
      });

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(src);
      player.poster(poster);

      player.reloadSourceOnError({
        // customize your interval
        errorInterval: 3,
      });

      player.on("error", () => {});
    }
  }, [videoRef, src, poster]);

  useEffect(() => {
    play ? playerRef.current.play() : playerRef.current.pause();
  }, [play]);

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player?.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  //Prevent video play closed browser:


  useEffect(() => {
    const handleWindowClose = () => {

      console.log('pauseee')
      !playerRef?.current.paused() && playerRef?.current.pause();

    }
    const handleBrowseAway = () => {
   
      console.log('pauseee')
      !playerRef?.current.paused() && playerRef?.current?.pause();

    }
    window.addEventListener('beforeunload', handleWindowClose)
    router.events.on('routeChangeStart', handleBrowseAway)
    return () => {
      window.removeEventListener('beforeunload', handleWindowClose)
      router.events.off('routeChangeStart', handleBrowseAway)
    }
  }, [])

  //Prevent video play closed browser

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};
